import { render } from "./TeamMemberCard.vue?vue&type=template&id=5fa8f0ed&scoped=true"
import script from "./TeamMemberCard.vue?vue&type=script&lang=js"
export * from "./TeamMemberCard.vue?vue&type=script&lang=js"

import "./TeamMemberCard.vue?vue&type=style&index=0&id=5fa8f0ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa8f0ed"]])

export default __exports__